const en_US_in_risks_page = {
  address: 'Address',
  type: 'Type',
};
const en_US = {
  deposit: 'Deposit',
  Deposit: 'Deposit',
  withdraw: 'Withdraw',
  Withdraw: 'Withdraw',
  swap: 'Swap',
  Swap: 'Swap',
  pool: 'Pool',
  Pool: 'Pool',
  pools: 'Pools',
  Pools: 'Pools',
  view_pools: 'View Pools',
  view_pool: 'View Pool',
  add_token: 'Add token',
  create_new_pool: 'Create new pool',
  Create_New_Pool: 'Create New Pool',
  your_liquidity: 'Your Liquidity',
  Your_Liquidity: 'Your Liquidity',
  farms: 'Farms',
  Farms: 'Farms',
  docs: 'Docs',
  account: 'Account',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'Connect to NEAR',
  slippage: 'Slippage tolerance',
  minimum_received: 'Minimum received',
  swap_rate: 'Swap rate',
  pool_fee: 'Pool fee',
  balance: 'Balance',
  from: 'From',
  to: 'To',
  submit: 'Submit',
  view_account: 'View Account',
  liquidity: 'Liquidity',
  tokens: 'Tokens',
  fee: 'Fee',
  fees: 'Fees',
  details: 'Details',
  detail: 'Detail',
  minimum_tokens_out: 'Minimum received',
  pair: 'Pair',
  tvl: 'TVL',
  add_liquidity: 'Add Liquidity',
  remove_liquidity: 'Remove Liquidity',
  total_liquidity: 'Total liquidity',
  my_shares: 'Shares',
  token: 'Token',
  enter_token_address: 'Enter token address',
  remove: 'Remove',
  select: 'Select',
  select_token: 'Select a token',
  total_fee: 'Total fee % ',
  start_at: 'Start at',
  end_at: 'End at',
  ended: 'ENDED',
  pending: 'PENDING',
  rewards_per_week: 'Rewards per week',
  apr: 'APR',
  total_staked: 'Total staked',
  unclaimed_rewards: 'Unclaimed rewards',
  claim: 'Claim',
  claim_all: 'Claim All',
  stake: 'Stake',
  unstake: 'Unstake',
  your_shares: 'Shares',
  cancel: 'Cancel',
  days: 'days',
  slippageCopyForMobile:
    'Slippage means the difference between what you expect to get and what you actually get due to other executing first',
  slippageCopy:
    'Slippage means the difference between what you expect to get and what you actually get due to other executing first',
  swapCopy:
    'Swap exchanges the first selected token with the second <br> selected token.The pools with the highest available liquidity and the lowest exchange fee will be used',
  addTokenCopy: 'Add any NEP-141 token',
  farmRewardsCopy: 'Indicative value based on prices and not actual execution',
  you_do_not_have_enough: "You don't have enough",
  is_not_exist: 'is not exist',
  must_input_a_value_greater_than_zero: 'Must input a value greater than 0',
  no_pool_available_to_make_a_swap_from:
    'No pool available to make a swap from',
  for_the_amount: 'for the amount',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: 'is not a valid swap amount',
  not_nep_address:
    'The address you entered is not a NEP-141 address, please check and enter it again. If it is another mainnet contract, go to Rainbow Bridge for bridging processing',
  not_correct_address:
    'The address you entered is incorrect, please check and enter',
  pool_id: 'Pool ID',
  more_pools: 'More pools',
  my_watchlist: 'My Watchlist',
  h24_volume: '24h volume',
  volume: 'Volume',
  hide_low_tvl_pools: 'Hide low TVL pools',
  hide_low_tvl_pools_mobile: 'Hide low TVL',
  my_watchlist_copy: 'Marked pools will appear here',
  language: 'Language',
  deposit_to_add_liquidity: 'Deposit to Add Liquidity',
  slip_warn: 'Be careful, please check the minimum you can receive',
  slip_invalid: 'The slippage tolerance is invalid',
  reward_tokens: 'Reward tokens',
  detail_tip: 'Detail',
  no_data: 'No Data',
  attention: 'Attention',
  live: 'Live',
  ended_search: 'Ended',
  my_farms: 'Your Farms',
  sort_by: 'Sort by',
  your_farms: 'Your farms',
  new: 'Latest',
  unstake_tip_t: 'you have rewards unclaimed...',
  unstake_tip_m:
    'Unstaking will remove the stake from all active and pending farms of the same pair.',
  unstake_tip_b: 'Do you want to unstake?',
  value_rewards: 'Claimed rewards',
  stake_unstake_tip:
    'Staking or unstaking will automatically claim your rewards.',
  over_tip: 'To optimise gas fee, you can withdraw up to 4 tokens at a time',
  no_token_tip: 'No reward token',
  getToken_tip: 'You can claim your rewards or stake your LP Tokens now!',
  in_farm: 'in Farm',
  price_impact: 'Price impact',
  roi_calculator: 'ROI Calculator',
  lp_staked: 'LP Tokens Staked',
  usd: 'USD',
  lp_token: 'LP Tokens',
  stake_for: 'Duration',
  day_1: '1D',
  day_2: '7D',
  day_3: '30D',
  day_4: '90D',
  cur_apr: 'ROI',
  reward_token: 'Reward tokens',
  get_lp_token: 'Get LP Tokens',
  calculate_roi: 'ROI calculator',
  rewards_claimed: 'Rewards claimed',
  value_rewards_token: 'Value of rewards',
  all: 'All',
  all_5: 'Max 4 tokens at a time',
  more_than: 'Please input number that more than or equal to 0.01',
  less_than: 'Please input number that less than 20',
  no_valid: 'Please input valid number',
  lp_fee: 'LP fee',
  referral_fee: 'Referral fee',
  protocol_fee_referral_fee: 'Protocol fee and Referral fee',
  total_fee_create: 'Total fee',
  ref: 'REF',
  are_you_sure: 'Are you sure',
  price_impact_is_about: 'Price impact is about',
  yes_swap: 'Yes, swap',
  input_greater_than_available_shares: 'Input greater than available shares',
  auto_router: 'Auto Router',
  optimal_path_found_by_our_solution: 'Optimal path found by our solution',
  make_sure_you_understand_what_you_do: 'Make sure you understand what you do',
  filter_by: 'Filter by',
  allOption: 'All',
  stablecoin: 'Stable',
  near_ecosystem: 'Near-eco',
  bridged_tokens: 'Bridged',
  gaming: 'Gaming',
  nft: 'NFT',

  bridge: 'Bridge to/from',
  no_result: 'Sorry, we couldn’t find any farm',
  multiple: 'Multiple',
  default: 'Default',
  create: 'Create',
  select_a: 'Select a',
  wallet: 'wallet',
  to_use_ref_finance: 'to use {appName}',
  not_supported: 'not supported',
  installed: 'installed',
  installe_now: 'install now',
  extension: 'extension',
  first_time_using_ref: 'First time using {appName}',
  learn_more: 'Learn more',
  install_sender_now: 'Install Sender Now',
  connect_to_dapps_with_one_click: 'Connect to dApps with one click',
  install: 'install',
  Connecting: 'Connecting',
  check_sender_wallet_extension: 'Please check Sender wallet extension',
  having_trouble: 'Having trouble?',
  go_back: 'Go back',
  web: 'web',
  Type: 'Type',
  click_to_view: 'Click to view',
  transaction_failed: 'Transaction failed',
  wallet_vi: ' ',
  value: 'Value',
  usd_value: 'USD Value',
  initialize_account_tip: 'Please initialize your account.',
  support_ledger_tip:
    "By design, Ledger cannot handle large transactions (i.e. Auto Router: trade across multiple pools at once) because of its memory limitation. When activated, the 'Support Ledger' option will limit transactions to their simplest form (to the detriment of potential optimal prices found by our Auto Router), so transactions of a reasonable size can be signed.",
  start: 'Start',
  max: 'Max',
  ref_account_balance_tip:
    'It seems like an error occurred while adding/removing liquidity to the pool',
  ref_account_tip_2: 'You have token(s) in your REF Account',
  ref_account_tip_top: 'your token(s) may be now in your REF inner account',
  click_here: 'Click here',
  to_recover_them: 'to recover them',
  ref_account_tip_3:
    'To withdraw token(s) from your REF Account to your NEAR Wallet, please select and withdraw',
  aurora_account_tip_4:
    'To withdraw token(s) from your Mapping Account to your NEAR Wallet, please select and withdraw',
  buy: 'Buy',
  sell: 'Sell',
  rate: 'Rate',
  name: 'Name',
  diff: 'Diff',
  best: 'Best',
  awesomeNear_verified_token: 'AwesomeNear Verified Token',
  pool_fee_apr: 'Pool fee APY',
  ref_account_balance_tip_mobile: 'You have tokens in your REF account.',
  click: 'Click',
  to_recover: 'to recover.',
  rewards_week: 'Rewards/week',
  rewards: 'Rewards',
  claimed_Rewards: 'Claimed Rewards',
  POOL: 'POOLS',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Append',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Rewards',
  free: 'Free',
  lp_tokens: 'LP tokens',
  connect_to_wallet: 'Connect Wallet',
  slash_policy_content:
    'Each seed has its own slash rate. And it will decreases linearly over time until be 0 at the unlock time of this CD Account.',
  not_expired: 'Not expired',
  accept_pay_slash_tip: 'I accept to pay slash',
  i_will_pay: 'I will pay',
  lp_token_slash: 'LP token exit fee.',
  expired: 'Expired',
  all_4_v2: '4 tokens/time',

  more_than_seed: 'Input must be greater than or equal to ',
  how_to_earn_more: 'How to compound rewards?',
  lock_your_lp_tokens_with_booster: 'Lock your LP tokens for boosted rewards',
  unstaked_anytime_no_booster: 'Unstaked anytime, no booster',
  locking_stake: 'Lock-up staking',
  change_to_lock: 'Change to Lock-up staking',
  estimated_rewards: 'Estimated rewards',
  final_booster: 'Final Booster',
  existing_amount: 'Existing amount',
  append_amount: 'Append amount',
  will_be_able_to_unstaked_after: 'will be able to unstaked after',
  you_have: 'You have',
  reward_apr: 'Rewards APR',
  stake_min_deposit: 'Input must be greater than or equal to ',
  unlock: 'Unlock',
  exit_fee: 'Exit fee',
  end_locking_period: 'End of locking period',
  add_lp_tokens_tip:
    'You need LP tokens to stake into the corresponding farm. First, add liquidity to the pool to get LP tokens.',
  slash_tip: 'Exit fee = Exit fee rate * End of locking period * Unlock amount',

  nonBoosted: 'Non-boosted',
  exit_fee_tip: 'Estimated amount you would pay to break your lock-up period',
  forbiddenTip: 'This farm does not support this duration option',
  unstakeTip: 'Staking or unstaking will automatically claim your rewards.',
  endedFarmsUnstakeTip:
    'Unstaking will remove the stake from all active and pending farms of the same pair. ',
  comimg: 'Coming',
  appendTip: 'Cannot be earlier than current locking time',
  week: 'week',
  yours: 'Yours',
  boost: 'Boost',
  near: 'NEAR',
  eth: 'ETH',
  others: 'Others',
  stakeLove: 'Stake LOVE',
  unstakeLove: 'Unstake LOVE',
  get_love: 'Get LOVE',
  swap_successful: 'Swap successfully. ',
  trading_successfull: 'Trading successful. ',
  available_to_stake: 'available to stake',
  your_assets: 'Your Assets',
  connect_wallet: 'Connect Wallet',
  disconnect: 'Disconnect',
  change: 'Change',
  connect: 'Connect',
  veTip: 'veLP tokens are not transferable, veLPT represent your voting power ',
  loveTip:
    'LOVE stands for Liquidity Of veToken. LOVE, like any NEP-141 token, is transferable and can be swapped, pooled, staked and farmed. LOVE represents the underlying liquidity of your veTokens',
  keep_ve: 'keep',
  months: 'months',
  month: 'month',
  lock_lp_tokens: 'Lock LP Tokens',
  get_lptoken: 'Get LP Tokens',
  duration: 'Duration',
  ve_lock_tip: 'Cannot be earlier than current unlocking date',
  get: 'Get',
  you_have_no_lp_share: 'You have no LP Tokens',
  lock: 'Lock',
  locked: 'Locked',
  available: 'Available',
  in: 'in',
  filter: 'Filter',
  options: 'options',
  ratio: 'Ratio',
  back: 'Back',
  confirm: 'Confirm',
  total: 'Total',
  type: 'Type',
  connect_to_near_wallet: 'Connect to NEAR Wallet',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: 'Classic farms update',
  migrate_now: 'Migrate Now!',
  v2_boost_tip:
    'The updated classic farms will support boosted farms. The Legacy farms will run dry of rewards on the <span class="font-bold">1st of August 2022</span>.',
  v2_boost_no_tip:
    'The Legacy farms will run dry of rewards on the <span class="font-bold">1st of August 2022</span>.',
  love: 'LOVE',
  Available_to_stake: 'Available to stake',
  you_staked: 'You staked',
  has_rewards_tip_in_v2:
    'Withdraw legacy rewards from <a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: 'How to get?',
  get_booster: 'Get Booster',
  ended_farms: 'ended farms',
  boosted_farms: 'Boosted farms',
  your_farm: 'Your farm',
  your_boosted_farms: 'Your boosted farms',
  search_farms_by_token: 'Search farms by token',
  search_farms: 'Search farms',
  more_lock_ve_popup2: 'more',
  left: 'left',
  create_pool: 'Create Pool',
  search_by_token: 'Search by token',
  your_power: 'Your Power',
  farm_has_boost_tip:
    'Your Power = Your staked LP Tokens * booster (by staking LOVE)',
  farm_no_boost_tip: 'Your Power = Your staked LP Tokens',
  more_than_a_simple_pool: 'More than a simple pool',
  ended_Farms: 'Ended Farms',
  vote_capital: 'VOTE',
  boostFarmTip: 'Get booster by staking LOVE',
  boosted: 'Boosted',
  love_staked: 'Staked LOVE',
  your_apr: 'Your APR',
  range_apr: 'Range or reference APR',
  no_pair_found: 'No pair found',
  found_stable_pool_in_sauce: 'Found stable pool in SAUCE',
  lp_tokens_locking: ' LP Tokens ',
  you_currently_have: 'You currently have ',
  scheduled_to_be_unlocked: 'scheduled to be unlocked',
  locking_more_lp_tokens: 'Locking more LP Tokens ',
  will_mean_these: 'will mean these ',
  lp_tokens_will_not_be_unlocked_until: ' LP Tokens will not be unlocked until',
  "I_understand_that_I_won't_be_able_to_remove_my":
    "I understand that I won't be able to remove my ",
  until: 'until',
  add: 'Add',
  finish: 'Finish',
  add_custom_network: 'Add Custom Network',
  network_name: 'Network Name',
  rpc_name_taken_tip: 'The network name was already taken',
  network_invalid: 'The network was invalid',
  fobidden_testnet_rpc_tip:
    "RPC server's network (testnet) is different with this network(mainnet)",
  no_support_testnet_rpc_tip: 'Testnet does not support adding custom RPC',
  stable: 'Stable',
  limit: 'Limit',
  your_active_orders_will_appear_here: 'Your active orders will appear here',
  your_history_orders_will_appear_here: 'Your history orders will appear here',
  farm_only: 'Farm only',
  please_confirm_this_transaction_on_ledger:
    'Please confirm this transaction on Ledger',
  limit_order: 'Limit Order',
  farm_stop_tip: 'This farm has been stopped.',
  pool_stop_tip: 'This pool has been stopped.',
  volume_24h: 'Volume (24h)',
  add_to_watchlist: 'Add to watchlist',
  remove_from_watchlist: 'Remove from watchlist',
  create_order: 'Create Order',
  filled: 'Filled',
  canceled: 'Canceled',
  partially_filled: 'Partially Filled',
  pool_composition: 'Pool Composition',
  amount: 'Amount',
  h24_volume_bracket: 'Volume(24h)',
  fee_24h: 'Fee(24h)',
  orders: 'Orders',
  your_orders: 'Your Orders',
  active: 'Active',
  history: 'History',
  you_sell: 'You Sell',
  you_buy: 'You Buy',
  fee_tiers: 'Fee tiers',
  created: 'Created',
  executed: 'Executed',
  actions: 'Actions',
  claimed_upper: 'Claimed',
  open_my_order: 'Open',
  initial_order: 'Initial Order',
  this_order_has_been_partially_filled: 'This order has been partially filled',
  filled_via_swap: 'Filled via swap',
  state: 'State',
  partially: 'Partially',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'No claimed rewards yet',
  out_of: 'out of',
  fee_Tiers: 'Fee Tiers',
  no_pool: 'No Pool',
  input_amount: 'Input Amount',
  update_range: 'Update Range',
  not_enough_balance: 'Not Enough Balance',
  set_price_range: 'Set Price Range',
  current_price: 'Current Price',
  invalid_range_tip:
    'Invalid range selected. The min price must be lower than the max price.',
  maket_price_outside_single_only_tip:
    'The market price is outside the price range. Add liquidity for the corresponding token.',
  min_price: 'Min Price',
  max_price: 'Max Price',
  min: 'Min',
  out_of_range: 'Out of range',
  in_range: 'In range',
  unclaimed_fees: 'Unclaimed Fees',
  your_position_will_be: 'Your position will be',
  at_this_price: 'at this price',
  price_range: 'Price Range',
  positions: 'Positions',
  position: 'Position',
  range: 'Range',
  login_risk_tip:
    'By checking this box and moving forward, you confirm that you fully understand the risks of using {appName}.',
  stable_pool: 'Stable Pool',
  market_rate: 'Market Rate',
  no_token_found: 'No token found',
  search_name_or_address: 'Search name or paste address...',
  token_address_invalid: 'The token address was invalid',
  price_impact_warning: 'Price Impact Warning',
  confirm_order: 'Confirm Order',
  you_Sell: 'You Sell',
  to_Buy: 'to Buy',
  at_Price: 'at Price',
  insufficient_balance: 'Insufficient Balance',
  limitTip: 'Your price is automatically set to the closest price slot',
  v2_pools: 'DCL Pools',
  v2_your_pool_introduction: 'Your discretized concentrated liquidity',
  v1_your_pool_introduction: 'Your liquidity in classic pools',
  estimate_value: 'Estimate Value',
  price: 'Price',
  '@price': '@Price',
  trades: 'Trades',
  time: 'Time',
  balances: 'Balances',
  asset: 'Asset',
  action: 'Action',
  market: 'Market',
  Maker: 'Maker',
  chart: 'Chart',
  refresh_data_to_continue: 'Please refresh the data to continue',
  refresh: 'Refresh',
  both: 'Both',
  All: 'All',
  Filled: 'Filled',
  assets: 'Assets',
  cancel_order: 'Cancel Order',
  instrument: 'Instrument',
  dex: 'Dex',
  limit_order_created: 'Limit Order Created',
  limit_order_filled: 'Limit Order Filled',
  classic_pools: 'Classic Pools',
  active_orders: 'Active Orders',
  your_liquidity_usd_value: 'Your Liquidity (USD value)',
  usage: 'Usage',
  holding: 'Holding',
  your_lp_tokens_and_shares: 'Your LP Tokens(Shares)',
  swapped: 'Swapped',
  dcl_pool: 'DCL Pool',
  classic: 'Classic',
  classic_farms: 'Classic Farms',
  locked_in: 'locked in',
  'deposit_near_tip_0.5': 'To deposit, keep at least 0.5 NEAR to cover gas fee',
  trade: 'Trade',
  earn_2: 'Earn',
  portfolio: 'Portfolio',
  more_2: 'More',
  liquidity_pools_2: 'Liquidity Pools',
  stable_pools: 'Stable Pools',
  pool_detail: 'Pool Detail',
  new_contract_deploy_tip:
    'A new contract has been deployed! Please remove your liquidity from the old contract',
  remove_will_automatically_claim:
    'Removing will automatically claim your unclaimed fees.',
  legacy_tip: 'Found unstaked LP tokens or rewards in',
  legacy_farms: 'Legacy Farms',
  all_farms: 'All Farms',
  your_farms_2: 'Your Farms',
  dcl_farms: 'DCL Farms',
  farm_type: 'Farm type',
  farm_2: 'Farm',
  to_claim: 'To Claim',
  liquidity_staked: 'Liquidity staked',
  dcl_pool_detail: 'DCL Pool Detail',
  reward_range: 'Reward Range',
  reward_range_tip: 'Farm reward within this range',
  ending_soon: 'Ending soon',
  farm_ended_tip: 'This farm has ended.',
  farm_will_ended_tip: 'This farm will end soon.',
  new_farm: 'New Farm',
  is_coming: 'is coming',
  est_apr: 'Est. APR',
  farming: 'Farming',
  unavailable: 'Unavailable',
  hide: 'Hide',
  show: 'Show',
  your: 'Your',
  max_apr: 'Max.APR',
  you_can_earn_tip: 'Farm available, farm APR up to',
  you_can_earn_current_tip:
    'Your current staked farm ended, and new farm is coming, est. APR is',
  go_new_farm: 'Go New Farm',
  go_farm: 'Go Farm',
  in_ended_farm: 'in ended farm',
  staked: 'Staked',
  in_farm_3: 'in farm',
  estimation: 'Estimation Value',
  this_staked_tip: 'This NFT has been staked',
  dcl_liquidity: 'DCL Liquidity',
  classic_liquidity: 'Classic Liquidity',
  will_appear_here_tip: 'Your liquidity positions will appear here.',
  dcl_will_appear_here_tip: 'Your DCL liquidity positions will appear here.',
  classic_will_appear_here_tip:
    'Your Classic liquidity positions will appear here.',
  price_range_overlap_ratio: ' Price Range Overlap Ratio',
  real_time_executed_orders: 'real-time executed orders',
  real_time_executed_orders_tip:
    'When placing a sell order above market price or a buy order below market price using limit order function, {appName} will attempt to execute a swap-with-stop-point action first, and if there is any remaining amount, a limit order will be created to fill the rest.<br> Real-time executed orders refer to orders placed using the limit order function but executed through swapping. In the "History" section, you can view real-time executed orders between the earliest displayed limit order in History up to the present time.',

  swapped_history_order: 'Swapped',
  ledger_guide_tip_1:
    'To successfully use your Ledger wallet for transactions, the ',

  ledger_guide_tip_2: 'feature has been automatically activated.',
  ledger_guide_tip_3: 'Please be aware',
  ledger_guide_tip_quote: '"',

  support_ledger_tip_new: 'Support Ledger',
  ledger_guide_tip_4:
    'that due to Ledger wallet constraints, the current rate provided by the swap function',
  ledger_guide_tip_5: 'may not be the best price',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Your Trade Route',
  markets: 'Markets',
  exchanges: 'Exchanges',
  output_est: 'Output (est.)',
  new_swap_order_tip:
    'The price is from the {appName} AMM and for reference only. There is no guarente that your limit order will be immediately filled. ',
  instants_swap: 'Instant Swap',
  swappped: 'Swapped',
  claimed: 'Claimed',
  executing_capital: 'Executing',
  trade_route: 'Trade Route',
  settings: 'Settings',
  no_trade_routes: 'No Trade Routes',
  steps_in_the_route: 'Steps in the Route',
  swap_chart_no_data: 'Not enough data for the chart right now.',
  last_updated: 'Last Updated',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: 'Supplied',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: 'Size',
};
export default Object.assign(en_US, en_US_in_risks_page);
